import src from "IMAGE";
export default { src, width: 500, height: 214, blurWidth: 0, blurHeight: 0};
